import { IEventCategory } from '../../types/mapped-event';
import { isSecureInput, VALIDATE_SECURE_INPUT_MESSAGE } from '@src/emp-3.0/utils';

export const validateMappedEventName = (mappedEventName: string) => {
  // Mapped event name need to less than 50
  if (mappedEventName.length > 50) {
    return {
      failed: true,
      message: 'Exceeds the maximum character limit (50)',
    };
  }

  // Validate legality
  // eslint-disable-next-line no-useless-escape
  const regex = /^[\u4e00-\u9fa5\w\s|()[\]\-\/\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}]+$/u;
  if (!regex.test(mappedEventName) && mappedEventName !== '') {
    return {
      failed: true,
      message:
        'Must contain only letters, numbers, spaces, emoji and special characters: _, (, ), [, ], /, -, |.',
    };
  }

  // SQL injection risk validation
  if (!isSecureInput(mappedEventName)) {
    return {
      failed: true,
      message: VALIDATE_SECURE_INPUT_MESSAGE,
    };
  }

  // Validate prefix
  const INVALID_PREFIX = 'conviva_';
  if (mappedEventName.toLowerCase().startsWith(INVALID_PREFIX)) {
    return {
      failed: true,
      message: `Cannot start with '${INVALID_PREFIX}'`,
    };
  }

  return { failed: false, message: 'passed' };
};

export const validateMappedEventMismatch = (
  mappedName: string,
  eventCategory: string,
  data: IEventCategory[] = [],
) => {
  const predefinedNames: string[] = [];
  data.forEach((category) => {
    predefinedNames.push(...(category.predefined_event_names ?? []));
  });
  return (
    !data
      .find((category) => category.category_name === eventCategory)
      ?.predefined_event_names?.includes(mappedName) && predefinedNames.includes(mappedName)
  );
};
